/** True when the key combo would reload the page in Chrome / Edge / Firefox. */
export function isBrowserReloadShortcut(event: KeyboardEvent): boolean {
  const ctrlOrCmd = event.ctrlKey || event.metaKey;
  const key = event.key;
  const code = event.code;
  const isF5 = key === 'F5' || code === 'F5' || event.keyCode === 116;
  const isR = key === 'r' || key === 'R' || code === 'KeyR';

  if (ctrlOrCmd && !event.altKey) {
    if (isR) {
      return true;
    }
    if (isF5) {
      return true;
    }
  }

  // Plain F5 — block page reload; app F5 handlers still run (preventDefault only).
  if (isF5 && !ctrlOrCmd && !event.altKey) {
    return true;
  }

  return false;
}
